import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sold-report-ticket-skeleton',
  templateUrl: './sold-report-ticket-skeleton.component.html',
  styleUrls: ['./sold-report-ticket-skeleton.component.scss'],
  standalone: false
})
export class SoldReportTicketSkeletonComponent {

  @Input() count: number = 2;

  get items(): number[] {
    return Array.from({ length: this.count }, (_, i) => i + 1);
  }

}
